var _defs, _path, _polyline, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrosimeToc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b54a4bed-b2b7-4f3d-9255-8c86970269fc",
    "data-name": "grosime_toc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.07 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a0015e10-f242-4059-b9c3-824487074155,.be4990a4-6244-432f-a7be-649c8cc1e901{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.be4990a4-6244-432f-a7be-649c8cc1e901{stroke-width:10px;}.a0015e10-f242-4059-b9c3-824487074155{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grosime_toc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "be4990a4-6244-432f-a7be-649c8cc1e901",
    d: "M55,195",
    transform: "translate(-0.5)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "be4990a4-6244-432f-a7be-649c8cc1e901",
    points: "54.5 5 54.5 195 144.5 195 144.5 30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accceac8-9ccc-4b49-9968-f9eba4ed7076",
    "data-name": "Arrow copy"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a0015e10-f242-4059-b9c3-824487074155",
    x1: 2.5,
    y1: 115,
    x2: 44.36,
    y2: 115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.94,131.8a1.76,1.76,0,0,1,.53-2.42L44.06,115,21.47,100.62a1.75,1.75,0,0,1,1.88-3l24.91,15.86a1.76,1.76,0,0,1,0,3L23.35,132.34a1.75,1.75,0,0,1-2.41-.54Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a0015e10-f242-4059-b9c3-824487074155",
    x1: 196.57,
    y1: 115,
    x2: 154.71,
    y2: 115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.13,98.2a1.75,1.75,0,0,1-.54,2.42L156,115l22.58,14.38a1.75,1.75,0,0,1,.54,2.42,1.77,1.77,0,0,1-2.42.54l-24.9-15.86a1.76,1.76,0,0,1,0-3l24.9-15.86a1.79,1.79,0,0,1,.94-.27A1.77,1.77,0,0,1,179.13,98.2Z",
    transform: "translate(-0.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrosimeToc);
export default __webpack_public_path__ + "static/media/grosime_toc.d311190273167f5bef14be6ed98a797c.svg";
export { ForwardRef as ReactComponent };